import { render, staticRenderFns } from "./Book1.vue?vue&type=template&id=17c9fc20&"
import script from "./Book1.vue?vue&type=script&lang=js&"
export * from "./Book1.vue?vue&type=script&lang=js&"
import style0 from "./Book1.vue?vue&type=style&index=0&id=17c9fc20&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports